/**
 * @desc 列表
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<Array<defs.appCenter.ApplicationResponseDto>>;
export function request(params: API.appCenter.app.list.Params, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/app/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
